import { ModuleInfo } from "../../services/interfaces/IHomePage";
import MapModulesToIcons from "../../utils/helpers/mapModulesToIcon";
import { numberFormatter } from "../../utils/formatter";
import { useNavigate } from "react-router-dom";
import { Dialog } from "primereact/dialog";
import { useState } from "react";
import CloseIcon from "../../assets/cross.svg";
import Button from "../button";
import moment from "moment";

type Props = {
  length: number;
  module: ModuleInfo;
  date: string;
  filter: Array<string>;
};

const ModuleCard = ({ length, module, date, filter }: Props) => {
  const [showRecommendation, setShowRecommendation] = useState<boolean>(false);

  const reviewStatus = {
    critical: "border-[#E49257] bg-[#FFF4ED] text-[#CD6318]",
    warn: "border-[#F3DE71] bg-[#FCFAF1] text-[#E9C400]",
    safe: "border-[#79B0E2] bg-[#F0F8FF] text-[#006FD5]",
  };

  const getReviewStatus = (daysLeft: number) => {
    if (daysLeft <= 0) {
      return "critical";
    } else if (daysLeft > 0 && daysLeft <= 10) {
      return "warn";
    } else {
      return "safe";
    }
  };

  const navigate = useNavigate();

  const navigateTo = () => {
    navigate(module.route);
  };

  const HeaderElement = (
    <div className="flex flex-row justify-between items-start">
      <div className="flex flex-col justify-start items-start gap-2">
        <span className="font-normal text-fs16 text-[#858585] h-[3vh]">
          {module.name}
        </span>
        <span className="font-bold text-fs24">Recommendations</span>
      </div>
      <div>
        <img
          className="cursor-pointer"
          src={CloseIcon}
          onClick={() => {
            setShowRecommendation(false);
          }}
        ></img>
      </div>
    </div>
  );

  const FooterElement = (
    <div className="flex justify-end items-center gap-4">
      <Button
        label="Close"
        bgColor="#949494"
        size="md"
        onClick={() => {
          setShowRecommendation(false);
        }}
      ></Button>
      <Button
        label="View Details"
        bgColor="#86BC25"
        size="md"
        onClick={() => {
          navigateTo();
        }}
      ></Button>
    </div>
  );

  return (
    <>
      <div
        className={`bg-white shadow-module-card rounded-md border border-[#BEBEBE] h-full w-[25%]`}
      >
        <div className="flex flex-col justify-between items-center px-[8%] py-[4%] h-full">
          <span
            style={
              module.days_left_for_review != null
                ? { visibility: "visible" }
                : { visibility: "hidden" }
            }
          >
            {module.days_left_for_review != null ? (
              <span
                className={`border rounded-[50px] font-semibold px-[0.7vw] py-[0.5vh] text-fs14 ${reviewStatus[getReviewStatus(module.days_left_for_review)]
                  }`}
              >
                Review{" "}
                {module.days_left_for_review > 0
                  ? `in ${module.days_left_for_review} day${module.days_left_for_review > 1 ? "s" : ""
                  }`
                  : "now"}
              </span>
            ) : (
              <span className="invisible">XYZ</span>
            )}
          </span>

          <span>
            <img
              className="w-[4vw] aspect-square"
              src={MapModulesToIcons(module.id)}
              alt={module.name}
            ></img>
          </span>
          <span className="font-bold text-[3vh] text-center px-[2.5vw]">
            {module.name}
          </span>
          <div className="flex flex-col justify-start items-center gap-0">
            <span className="font-normal text-[5vh]">
              {module?.id === "nia_opportunity"
                ? "$" + module.opportunity + "M"
                : module?.id === "business_cost"
                  ? module?.opportunity !== null
                    ? numberFormatter(module.opportunity * 100, 1) + "%"
                    : "-"
                  : module?.opportunity !== null
                    ? numberFormatter(
                      module.opportunity,
                      numberFormatter(module.opportunity).slice(-1) === "M"
                        ? 1
                        : 0,
                      "$"
                    )
                    : "-"}
            </span>

            {!["compliance_monitoring", "nia_opportunity"].includes(
              module.id
            ) &&
              module?.opportunity !== null && (
                <span className="text-[#858585] text-fs12">
                  {module.districts_reviewed_x} out of{" "}
                  {module.total_districts_y} districts finalized
                </span>
              )}
          </div>
          {module?.opportunity !== null ? (
            <>
              <span
                onClick={() => {
                  setShowRecommendation(true);
                }}
                className="text-[1.6vh] font-bold bg-deloitteGreen rounded text-white px-[1.2vw] py-[1vh] cursor-pointer"
              >
                View Recommendations
              </span>
            </>
          ) : (
            <>
              <span className="text-[1.6vh] font-bold bg-gray-400 rounded text-white px-[1.2vw] py-[1vh] cursor-not-allowed">
                View Recommendations
              </span>
            </>
          )}
        </div>
      </div>

      <Dialog
        draggable={false}
        visible={showRecommendation}
        modal
        header={HeaderElement}
        footer={FooterElement}
        style={{ width: "35vw" }}
        closable={false}
        onHide={() => {
          setShowRecommendation(false);
        }}
      >
        <div className="flex flex-col justify-start items-start py-[2vh] px-[1vw] gap-4 approval-dialog">
          {module.id === "upcoming_negotiations" && showRecommendation && (
            <ol className="list-decimal flex flex-col justify-start items-start gap-2 p-[1vh]">
              {module.recommendation.min_percent_difference_x != null &&
                module.recommendation.min_percent_difference_x > 0 &&
                module.recommendation.max_percent_difference_y != null &&
                module.recommendation.max_percent_difference_y > 0 && (
                  <li className="text-fs16 font-normal">
                    Further negotiations are needed with{" "}
                    <span className="font-bold">
                      {module.recommendation.vendor_names?.join(", ")}&nbsp;
                    </span>
                    to reduce the quotes by{" "}
                    <span className="font-bold">
                      {module.recommendation.min_percent_difference_x ===
                        module.recommendation.max_percent_difference_y
                        ? `${numberFormatter(
                          (module.recommendation.min_percent_difference_x ||
                            0) * 100,
                          1
                        )}%`
                        : `${numberFormatter(
                          (module.recommendation.min_percent_difference_x ||
                            0) * 100,
                          1
                        )}% - ${numberFormatter(
                          (module.recommendation.max_percent_difference_y ||
                            0) * 100,
                          1
                        )}%`}
                    </span>{" "}
                    in the{" "}
                    <span className="font-bold">
                      {filter && filter.length > 0
                        ? filter.length === 1
                          ? `${filter[0]}.`
                          : `${filter.length} districts.`
                        : module.recommendation.district_count_x +
                        " districts."}
                    </span>{" "}
                  </li>
                )}
              {module.recommendation.incremental_spend !== undefined &&
                module.recommendation.incremental_spend !== 0 && (
                  <li className="text-fs16 font-normal">
                    Purchasing{" "}
                    <span className="font-bold">
                      {module.recommendation.truck_load_count} TLs
                    </span>{" "}
                    from the recommended supplier will result in a savings of{" "}
                    <span className="font-bold">
                      {numberFormatter(
                        module.recommendation.incremental_spend || 0,
                        2,
                        "$"
                      )}
                    </span>
                    .
                  </li>
                )}
            </ol>
          )}

          {module.id === "business_cost" && showRecommendation && (
            <ol className="list-decimal flex flex-col justify-start items-start gap-2 p-[1vh]">
              {module.recommendation.last_month_avg_x != null && (
                <li className="text-fs16 font-normal">
                  Follow up with{" "}
                  <span className="font-bold">
                    {filter && filter.length > 0
                      ? filter.length === 1
                        ? `${filter[0]} `
                        : `${filter.length} districts`
                      : module.recommendation.district_count_x + " districts "}
                  </span>{" "}
                  for non-compliance to{" "}
                  <span className="font-bold">
                    {moment.utc(date).subtract(1, "month").format("MMMM")}'s
                  </span>{" "}
                  finalized board cost by{" "}
                  <span className="font-bold">
                    {numberFormatter(
                      (module.recommendation.last_month_avg_x || 0) * 100,
                      1
                    )}
                    %
                  </span>{" "}
                  on avg.
                </li>
              )}
              <li className="text-fs16 font-normal">
                Adjust{" "}
                <span className="font-bold">
                  {moment.utc(date).format("MMMM")}'s
                </span>{" "}
                board cost by avg{" "}
                <span className="font-bold">
                  {/* {numberFormatter(
                    (module.recommendation.current_mont_avg_x || 0) * 100,
                    0
                  )} */}
                  {module?.opportunity &&
                    numberFormatter(module.opportunity * 100, 1)}
                  %
                </span>{" "}
                <span>
                  {filter && filter.length > 0
                    ? filter.length === 1
                      ? `in ${filter[0]}`
                      : `across districts `
                    : " across districts "}
                </span>{" "}
                based on finalized board cost.
              </li>
            </ol>
          )}

          {module.id === "compliance_monitoring" && showRecommendation && (
            <ol className="list-decimal flex flex-col justify-start items-start gap-2 p-[1vh]">
              {(module?.minPercentage != null && module?.minPercentage > 0) ||
                (module?.maxPercentage != null && module?.maxPercentage > 0) ? (
                <li className="text-fs16 font-normal">
                  Discuss with{" "}
                  <span className="font-bold">
                    {filter && filter.length > 0
                      ? filter.length === 1
                        ? `${filter[0]} `
                        : `${filter.length} districts`
                      : `${module.total_districts_commitment} districts`}
                  </span>{" "}
                  on Purchasing{" "}
                  <span className="font-bold">
                    {module?.minPercentage?.toFixed(2) ===
                      module?.maxPercentage?.toFixed(2)
                      ? `${module?.minPercentage?.toFixed(2) || 0}%`
                      : `${module?.minPercentage?.toFixed(2) || 0}% - ${module?.maxPercentage?.toFixed(2) || 0
                      }%`}
                  </span>{" "}
                  overpayments and attempt to recover cost
                </li>
              ) : null}

              {module?.count_vendors_exceeding_commitment &&
                module?.count_vendors_exceeding_commitment?.length > 0 && (
                  <li className="text-fs16 font-normal">
                    Ensure meeting volume commitment for{" "}
                    <span className="font-bold">
                      {Array.isArray(
                        module?.count_vendors_exceeding_commitment
                      ) &&
                        module?.count_vendors_exceeding_commitment?.length !==
                        0 &&
                        module?.count_vendors_exceeding_commitment?.join(" , ")}
                    </span>{" "}
                    in{" "}
                    {/* <span className="font-bold">{module?.total_districts}</span>{" "}
                    districts */}
                    <span className="font-bold">
                      {filter && filter.length > 0
                        ? filter.length === 1
                          ? `${filter[0]}.`
                          : `${filter.length} districts.`
                        : module.total_districts + " districts."}
                    </span>{" "}
                  </li>
                )}
            </ol>
          )}

          {module.id === "nia_opportunity" && showRecommendation && (
            <ol className="list-decimal flex flex-col justify-start items-start gap-2 p-[1vh]">
              <li className="text-fs16 font-normal">
                Improve NIA terms by{" "}
                <span className="font-bold">
                  {module?.minPercentage?.toFixed(2) || 0}% -{" "}
                  {module?.maxPercentage?.toFixed(2) || 0}%
                </span>{" "}
                for <span className="font-bold"> {module?.total_vendors} </span>{" "}
                suppliers to match best-in-class peer
              </li>

              <li className="text-fs16 font-normal">
                Introduce growth terms based on recommended tier benchmarks
              </li>
            </ol>
          )}
        </div>
      </Dialog>
    </>
  );
};

export default ModuleCard;
